<template>
    <div class="side-panel-banner-copy-value">
        <section class="side-panel-banner-copy-value-enable">
            <v-checkbox
                class="interaction-option-enable-checkbox"
                v-model="showcopyValueInput"
                :ripple="false"
                hide-details
            ></v-checkbox>
            <h6 class="side-panel-banner-copy-value-checkbox-title">
                {{ $t('message.campaigns.message.defineCopyVal') }}
            </h6>
        </section>
        <section v-if="showcopyValueInput">
            <v-text-field
                :label="$t('message.campaigns.message.copyVal')"
                v-model="copyValue"
                :error-messages="copyValueError"
                @blur="emitForm"></v-text-field>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        interaction: {
            type: Object,
        },
    },
    data() {
        return {
            showcopyValueInput: false,
            copyValue: undefined,
            copyValueError: "",
        };
    },

    watch: {
        showcopyValueInput(value) {
            if (!this.copyValue && !value) return;

            if (!value) {
                this.copyValue = null;
                this.emitForm();
            }
        },
        copyValue(value) {
            this.copyValueError = "";

            if (!value) return;

            if (value.length > 60) {
                this.copyValueError = `O limite do tamanho é de 60 caracteres.`;
            }
        },
    },

    methods: {
        emitForm() {
            if (this.copyValueError) return;

            this.$emit("input", {
                copyValue: this.copyValue,
                tipo: "BANNER"
            });
        },
    },

    mounted() {
        if (this.interaction.copyValue) {
            this.showcopyValueInput = true;
            this.copyValue = this.interaction.copyValue;
        }
    },
};
</script>

<style lang="scss" scoped>
.side-panel-banner-copy-value {
    display: flex;
    flex-direction: column;

    .side-panel-banner-copy-value-enable {
        display: flex;
        align-items: center;
        justify-content: start;
    }

    .interaction-option-enable-checkbox {
        flex: 0;
        padding: 0;
        h6 {
            margin-bottom: 0;
        }
    }
}

.side-panel-banner-copy-value-checkbox-title {
    margin: 0;
}

.side-panel-banner-copy-value-error {
    font-size: 12px;
}
</style>
